import { render, staticRenderFns } from "./CourseListing.vue?vue&type=template&id=70bb2d76&"
import script from "./CourseListing.vue?vue&type=script&lang=ts&"
export * from "./CourseListing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports